
import { useModal } from '../contexts';
import Modal from './Modal';
import { HubspotPrimaryObject } from "../interfaces";
import { capitalize } from '../utils';


interface Props {
  object: HubspotPrimaryObject;
  onConfirm: (object: HubspotPrimaryObject) => void;
}

function WorkflowModalHubspotConfirmation(props: Props) {
  const { closeModal } = useModal();

  return (
    <Modal>
      <div className="flex flex-col p-2 w-[600px] min-h-[400px]">
        <div className="font-gilroy font-semibold text-lg">Change Primary Object</div>
        <div className="mt-1 font-semibold text-gray-600 text">Please confirm that you would like to change the primary object for this HubSpot source.</div>

        <div className="flex flex-col mt-auto font-semibold font-gilroy text-center text-lg text-gray-600">
          New primary object:
        </div>
        <div className="flex flex-col mt-1 font-semibold font-gilroy text-center text-2xl">
          {capitalize(props.object)}
        </div>
        <div className='flex items-center justify-between mt-auto'>
          <button onClick={() => closeModal()}>
            Cancel
          </button>
          <button className='btn btn-blue' onClick={() => { props.onConfirm(props.object); closeModal(); }}>
            Confirm
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default WorkflowModalHubspotConfirmation;
